import logger from "logging/logger";
import { getEventPrefix } from "modules/event/firebase";
import { addUsersInEvent } from "modules/event/usersInEvent/actions";
import React from "react";
import { useAppDispatch } from "store/hooks";
import { USER_PATH } from "services/firebaseService/storagePaths";
import { IEvent } from "modules/event/types";
import { IUser } from "modules/app/types";
import { ref, get } from "firebase/database";
import { database } from "../../../services/firebaseService/firebaseConfig";

// This hook could be removed after we fix the missing avatar isse
const useMissingUserInSpace = () => {
  const dispatch = useAppDispatch();

  const handleMissingAvatar = React.useCallback(
    (
      currentUser: IUser | undefined,
      userInSpace: IUser | undefined,
      currentEvent: IEvent | null,
      userId: string,
      roomId: string,
      // eslint-disable-next-line max-params
    ) => {
      if (!userId || !currentEvent) {
        logger.info("[handleMissingAvatar] missing userId", {
          currentUser,
          userInSpace,
          userId,
          roomId,
        });

        return;
      }

      // If user in space missing, get it from firebase again
      if (!userInSpace) {
        logger.warn(
          `[handleMissingAvatar] getting ${userId} for ${currentEvent?.id}`,
        );
        const usersRef = ref(
          database,
          `${getEventPrefix()}/${currentEvent?.id}/${USER_PATH}/${userId}`,
        );

        get(usersRef)
          .then((snap) => {
            const userDetails = snap.val();

            // If user details are available
            // eslint-disable-next-line promise/always-return
            if (userDetails) {
              dispatch(addUsersInEvent(userId, userDetails));
              // Confirm if user avatar can be seen after 2s
              setTimeout(() => {
                const avEl = document.getElementById(`map-av-${userId}`);

                if (!avEl) {
                  logger.warn(
                    `[handleMissingAvatar] no avatar yet missing details: ${userId} room: ${roomId}`,
                    {
                      currentUser,
                      userInSpace,
                      currentEvent: currentEvent?.id,
                    },
                  );
                } else {
                  logger.info(
                    `[handleMissingAvatar] got ${userId} for ${currentEvent?.id} after 5s`,
                  );
                }
              }, 5000);
            } else {
              logger.warn(
                `[handleMissingAvatar] user missing details: ${userId} room: ${roomId}`,
                { currentUser, userInSpace, currentEvent: currentEvent?.id },
              );
            }
          })
          .catch((error) => {
            logger.error(`[handleMissingAvatar] Error fetching user: ${error}`);
          });
      } else {
        logger.warn(
          `[handleMissingAvatar] missing details: ${userId} room: ${roomId}`,
          { currentUser, userInSpace, currentEvent: currentEvent?.id },
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return {
    handleMissingAvatar,
  };
};

export default useMissingUserInSpace;
